module.exports = __webpack_public_path__ + "static/home-hero-93243837f97260835ee2d5a08a40c60c.mp4";